import "./SingleTournoiTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleTournoiTemplateSection from "./sections/SingleTournoiTemplateSection"
import RejoignezLAventure from "@/reusable_sections/Footer"

export default function SingleTournoiTemplatePage() {

  return (
    <div>
      <Header />
      <SingleTournoiTemplateSection />
      <RejoignezLAventure />
    </div>
  )
}
